import React from 'react';
import { motion } from 'framer-motion';
import { Container, Typography, Button, Box } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

const Hero = ({ apkUrl }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '3rem', md: '6rem', lg: '8rem' },
                fontWeight: 900,
                mb: 6,
                background: 'linear-gradient(135deg, #ffffff 0%, #cccccc 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              STOCK POLICE
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.95 }}
            style={{ display: 'inline-block' }}
          >
            <Button
              variant="contained"
              size="large"
              component="a"
              startIcon={<DownloadIcon />}
              href={apkUrl}
              download="StockPolice_v2.0.0.apk"
              sx={{
                px: 6,
                py: 3,
                fontSize: '1.2rem',
                fontWeight: 600,
                boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)',
              }}
            >
              Download Stock Police App
            </Button>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
